
import { defineComponent } from "vue";
import { useStore } from "@/store";

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    return {
      store,
      props,
    };
  },
});
